<template>
  <v-card outlined>
    <v-data-table
      v-model="selected"
      :items="list"
      :headers="headers"
      :loading="loading"
      :sort-by="['modifiedDate']"
      :sort-desc="[true]"
      :search="filter.search"
      class="row-pointer"
      show-select
      item-key="id"
      :footer-props="{
        'items-per-page-options': [100, 250, 500, 1000]
      }"
      @click:row="rowClick"
    >
      <template #[`header.published`]="{}">
        <v-icon small> wifi </v-icon>
      </template>

      <template #[`item.published`]="{ item }">
        <v-icon
          small
          :color="item.published ? 'success' : 'error'"
        >
          wifi
        </v-icon>
      </template>
      <template #[`item.imageFlatSide1Thumb`]="{ item }">
        <v-img
          v-if="item.imageFlatSide1Thumb"
          :src="item.imageFlatSide1Thumb"
          width="100"
          contain
          class="my-1"
        />
      </template>
      <template #[`item.imageFlatSide2Thumb`]="{ item }">
        <v-img
          v-if="item.imageFlatSide2Thumb"
          :src="item.imageFlatSide2Thumb"
          width="100"
          contain
          class="my-1"
        />
      </template>
      <template #[`item.coreProductId`]="{ item }">
        {{ product_name(item.coreProductId) }}
      </template>
      <template #[`item.resizedToCoreProductIds`]="{ item }">
        <div
          v-for="id in item.resizedToCoreProductIds"
          :key="id"
        >
          {{ product_name(id) }}
        </div>
      </template>
      <template #[`item.resizeDefaultCoreProductIds`]="{ item }">
        <div
          v-for="id in item.resizeDefaultCoreProductIds"
          :key="id"
        >
          {{ product_name(id) }}
        </div>
      </template>
      <template #[`item.modifiedDate`]="{ item }">
        {{ item.modifiedDate | normalDateWithTime }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          color="primary"
          class="mr-2"
          :loading="saving"
          @click.prevent.stop="rowClick(item)"
        >
          Edit & Copy
        </v-btn>
        <v-btn
          color="primary"
          class="mr-2"
          :loading="saving"
          @click.prevent.stop="copy(item)"
        >
          Copy
        </v-btn>
        <v-btn
          color="error"
          class="mr-2"
          :loading="saving"
          @click.prevent.stop="ignoreResize(item)"
        >
          Ignore
        </v-btn>
      </template>
    </v-data-table>
    <TemplateCopy ref="copy" />
  </v-card>
</template>

<script>
import TemplateCopy from '@/components/templates/Copy';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogCopyTemplates',
  components: { TemplateCopy },
  data: () => {
    return {
      headers: [
        { value: 'published' },
        { value: 'imageFlatSide1Thumb' },
        { value: 'imageFlatSide2Thumb' },
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Product', value: 'coreProductId' },
        {
          text: 'Modified',
          value: 'modifiedDate'
        },
        {
          text: 'Copy To',
          value: 'resizeDefaultCoreProductIds',
          sortable: false
        },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false,
      saving: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    selected: {
      get() {
        return this.$store.getters['catalog/selected'];
      },
      set(val) {
        this.$store.dispatch('catalog/setSelected', val);
      }
    },
    ...mapGetters({
      list: 'templates/copy',
      product_name: 'lookup/product_name'
    })
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('templates/loadCopy', this.filter),
      this.$store.dispatch('catalog/filter', Object.assign(this.filter, {}))
    ])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$refs.copy.show({ templateIds: [item.id] });
    },
    copy(item) {
      this.saving = true;
      this.$store
        .dispatch('templates/copyDefaults', [item])
        .then(() => {
          this.$root.$snackbarSuccess('Templates copied');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    ignoreResize(item) {
      this.saving = true;
      this.$store
        .dispatch('templates/ignoreResize', [item.id])
        .then(() => {
          this.$root.$snackbarSuccess('Templates ignored');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
